import { ModalAnalyticsEvent } from '@40seas/payments-shared';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDashboardEventTracker } from '../../hooks/useDashboardEventTracker/useDashboardEventTracker';
import { InactivityPopupView } from './InactivityPopupView';

export const InactivityPopup = () => {
    const [inactive, setInactive] = useState(false);
    const tracker = useDashboardEventTracker();
    const trackOpenDialog = tracker.useTrackClick(ModalAnalyticsEvent.OPEN_DIALOG);

    const timeout = 4 * 60 * 60 * 1000;

    const onIdle = () => {
        if (!timeout) return;

        setInactive(true);
        trackOpenDialog('inactivity-popup');
    };

    useIdleTimer({
        onIdle,
        timeout,
        disabled: inactive || !timeout,
    });

    useEffect(() => {
        if (!timeout) return;

        clearReloadToken();
    }, []);

    const refreshPage = () => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('_reload', String(Date.now()));
        window.location.href = currentUrl.toString();
    };

    if (inactive) {
        return <InactivityPopupView onRefreshClicked={refreshPage} />;
    }

    return null;
};

function clearReloadToken() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('_reload')) {
        searchParams.delete('_reload');
        const newUrl = `${window.location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
        window.history.replaceState({}, '', newUrl);
    }
}
